import { types, isType } from "mobx-state-tree"

export const User = types.model({
    _id: types.identifier,
    nonce: types.number,
    username: types.optional(types.string, ""),
    role: types.string,
    publicAddress: types.string,
    mvuAllowance: types.optional(types.number, 0),
    mvuBalance: types.optional(types.number, 0),
    betsMade: types.optional(types.array(types.string), []),
    customWagersMade: types.optional(types.array(types.string), []),
    customWagersTaken: types.optional(types.array(types.string), []),
    customWagersJudged: types.optional(types.array(types.string), []),
    oracles: types.optional(types.array(types.string), []),
    betsTaken: types.optional(types.array(types.string), []),
    totalAmountBet: types.optional(types.number, 0),
    numBetsWon: types.optional(types.number, 0),
    termsAgreedTo: types.optional(types.boolean, false),
    teamsFollowed: types.optional(types.array(types.string), []),
    leaguesFollowed: types.optional(types.array(types.string), []),
    categoriesFollowed: types.optional(types.array(types.string), []),
    amountEthWon: types.optional(types.number, 0)
});


// WEBPACK FOOTER //
// ./src/models/User.js